import React from 'react';
import cmsUtils from '../../cmsUtils';
import utils from '../../../../utils';
// import { YoutubeBannerMobilePopup } from '../../../../lib/youtube/youtubeBanner--mobilePopup';
import { YoutubeNew } from 'cms/items/youtubeNew/view';
import { SearchBar } from 'layout/topHeader/searchBar2';

export function VideoPanel(props) {
  const item = props.item;
  const cmsOption = props.cmsOption || {};

  //console.log('item', item);

  const heightSet = cmsUtils.payload(item, 'HeightSet') || 'standard';
  const videoCode = cmsUtils.payload(item, 'YoutubeCode');
  const posterFrameUrl = cmsUtils.payload(item, 'PosterFrameUrl', null);
  const playerId = 'ytBanner-' + (item.itemId).substr(0, 8);

  const video = {
    heightSet: heightSet,
    videoLinkOrId: videoCode,
    playerId: playerId
  }

  const useSearch = cmsUtils.payload(item, 'UseSearch') || 'false';
  const videoLogo = cmsUtils.payload(item, 'VideoLogo') || 'true';

  //const enableYoutube = env.isProd;
  const canPlayVideo = () => utils.css.screenWidth() >= 0

  const cssClass = utils.classNames('cms_item', 'youtubePanel', item.cssClass || item.anchorName || '');

  //console.log(window.innerWidth, canPlayVideo())

  return (
    <div
      className={cssClass}
      data-cms-item-id={cmsOption.isCmsEdit && item.itemId}
      id={item.anchorName}
      style={{ position: 'relative', overflow: 'hidden' }}
    >
      {/* Video overlay graphic */}
      {/* <img
        src={'assets/video-overlay.png'}
        alt="Video Overlay"
        className="video-overlay-graphic"
        style={{
          position: 'absolute',
          top: '50%',
          left: 0,
          width: '30%',
          height: '30%',
          transform: 'translateY(-50%)', // Vertically center the overlay
          pointerEvents: 'none', // ensures overlay doesn't block interaction
          zIndex: 2 // sits above video, but below any modal/popups
        }}
      /> */}
      {/* 
        Use a <div> with the SCSS class for the overlay graphic.
        Make sure the SCSS file is imported at a global or component level.
        If the overlay is not visible, check that the SCSS is loaded and the path to the image is correct.
      */}
      {
        videoLogo === 'true' && 
        <div className="video-overlay-graphic" />
      }
      <YoutubeNew
        video={video}
        canPlayVideo={canPlayVideo}
        posterImageUrl={utils.site.resourcePath(posterFrameUrl)}
      />
      {
        useSearch === 'true' && 
      <div className="bottom-search-container">
        {/* <h3>Find what you are looking for in the Copper Coast!</h3> */}
        <SearchBar />
      </div>
      }
    </div>
  );
}
